import { formatPrice, type Locale, defaultLocale, isValidLocale } from "@/config/locale";
import { getCheckoutCurrencyCode } from "@/config/currencies";

export type ResolvedMoneyPresentation = {
	/** Same as canonicalLabel (Saleor channel currency only). */
	primaryLabel: string;
	canonicalLabel: string;
	showDual: boolean;
	/** Channel settlement ISO code (EUR / USD) */
	checkoutCurrencyCode: "EUR" | "USD";
};

export function resolveMoneyPresentationSync(params: {
	amount: number;
	currency: string;
	locale: string;
	channel: string;
}): ResolvedMoneyPresentation {
	const loc: Locale = isValidLocale(params.locale) ? params.locale : defaultLocale;
	const checkoutCurrencyCode = getCheckoutCurrencyCode(params.channel);
	const canonical = params.currency.toUpperCase();
	const amount = Number.isFinite(params.amount) ? params.amount : 0;
	const canonicalLabel = formatPrice(amount, canonical, loc);

	return {
		primaryLabel: canonicalLabel,
		canonicalLabel,
		showDual: false,
		checkoutCurrencyCode,
	};
}

/** Dedupe helper for PDP: cache by `${currency}:${amount}` (stable float key). */
export function buildResolvedMoneyKey(amount: number, currency: string): string {
	const n = Number.isFinite(amount) ? Math.round(amount * 1e6) / 1e6 : 0;
	return `${currency.toUpperCase()}:${n}`;
}
